import React from 'react';
import { pathOr } from 'ramda';
import { Tabs } from 'antd';
import Translate from 'react-translate-component';

import CompanyGeneral from './fields/CompanyGeneral';
import CompanyComments from 'components/common/fields/CommentsField';
import CompanyClassifier from 'components/common/fields/ClassifierFields';
import CompanyLinks from './fields/CompanyLinks';
import CompanyLegals from './fields/CompanyLegals';
import CompanyStructure from './tabs/CompanyStructure';
import CompanyEmployees from './tabs/CompanyEmployees';
import CompanyLabels from './fields/CompanyLabels';

import { DocumentTabHeader } from 'components/common/fields/DocumentTabHeader';
import DocumentList from 'components/common/fields/DocumentList';
import { notEmpty } from 'utils/ramdaAdditions';

const getDocCount = pathOr(0, ['documents', 'length']);

export default function CompanyCard ({ company, meta }) {
    const docsCount = getDocCount(company);

    const GeneralTabHead = <Translate content="company.company_information" component="span" />;
    const DocumentTabHead = <DocumentTabHeader docsCount={ docsCount } />;
    const DepartmentTabHead = <Translate content="company.department" component="span" />;
    const EmployeesTabHead = <Translate content="company.employees.title" component="span" />;

    return (
        <div>
            { notEmpty(company) && (
                <Tabs defaultActiveKey="general">
                    <Tabs.TabPane key="general" tab={ GeneralTabHead }>
                        { meta.success && (
                            <div>
                                <CompanyGeneral company={ company } />
                                <CompanyClassifier classifiers={ company.classifier } />
                                <CompanyLinks links={ company.links } />
                                <CompanyLegals legals={ company.legal } />
                                <CompanyLabels labels={ company.labels } />
                                <CompanyComments comments={ company.comment } />
                            </div>
                        )}
                    </Tabs.TabPane>
                    <Tabs.TabPane key="structure" tab={ DepartmentTabHead }>
                        { meta.success && <CompanyStructure id={ company.id } /> }
                    </Tabs.TabPane>
                    <Tabs.TabPane key="employees" tab={ EmployeesTabHead }>
                        { meta.success && <CompanyEmployees id={ company.id } type={ company.type } /> }
                    </Tabs.TabPane>
                    <Tabs.TabPane key="documents" tab={ DocumentTabHead }>
                        { meta.success && <DocumentList documents={ company.documents } /> }
                    </Tabs.TabPane>
                </Tabs>
            )}
        </div>
    );
}
